import logo from './logo.svg';
import './App.css';
import MyNavbar from './components/MyNavbar';
import MyHeader from './components/Header';
import SocialSection from './components/SocialSection';
import Footer from './components/Footer';
import ContactSection from './components/ContactSection';
import Impressum from './components/Impressum';


function App() {
  return (
    <div className="App">
        <MyNavbar></MyNavbar>
        <MyHeader></MyHeader>
        <SocialSection></SocialSection>
        <ContactSection></ContactSection>
        <Impressum></Impressum>
    </div>
  );
}

export default App;
